import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

export const PAYS = [
    { id: '1', code: 'FR', name: 'France', phoneCode: '+33' },
    { id: '2', code: 'BE', name: 'Belgique', phoneCode: '+32' },
    { id: '3', code: 'CA', name: 'Quebec', phoneCode: '+1' },
    { id: '4', code: 'CH', name: 'Suisse', phoneCode: '+41' },
    { id: '5', code: 'RE', name: 'La Réunion', phoneCode: '+262' },
    { id: '6', code: 'GP', name: 'Guadeloupe', phoneCode: '+590' },
    { id: '7', code: 'MQ', name: 'Martinique', phoneCode: '+596' },
    { id: '8', code: 'LU', name: 'Luxembourg', phoneCode: '+352' },
    { id: '9', code: 'PF', name: 'Polynésie Française', phoneCode: '+689' },
    { id: '10', code: 'DZ', name: 'Algérie', phoneCode: '+213' },
    { id: '11', code: 'TN', name: 'Tunisie', phoneCode: '+216' },
    { id: '12', code: 'MA', name: 'Maroc', phoneCode: '+212' },
    { id: '13', code: 'AD', name: 'Andorre', phoneCode: '+376' },
    { id: '14', code: 'BJ', name: 'Bénin', phoneCode: '+229' },
    { id: '15', code: 'BF', name: 'Burkina Faso', phoneCode: '+226' },
    { id: '16', code: 'BI', name: 'Burundi', phoneCode: '+257' },
    { id: '17', code: 'CM', name: 'Cameroun', phoneCode: '+237' },
    { id: '18', code: 'CF', name: 'République centrafricaine', phoneCode: '+236' },
    { id: '19', code: 'KM', name: 'Comores', phoneCode: '+269' },
    { id: '20', code: 'CG', name: 'République du Congo', phoneCode: '+242' },
    { id: '21', code: 'CD', name: 'République démocratique du Congo', phoneCode: '+243' },
    { id: '22', code: 'CI', name: 'Côte d\'Ivoire', phoneCode: '+225' },
    { id: '23', code: 'DJ', name: 'Djibouti', phoneCode: '+253' },
    { id: '24', code: 'DM', name: 'Dominique', phoneCode: '+1767' },
    { id: '25', code: 'GA', name: 'Gabon', phoneCode: '+241' },
    { id: '26', code: 'GN', name: 'Guinée', phoneCode: '+224' },
    { id: '27', code: 'GQ', name: 'Guinée équatoriale', phoneCode: '+240' },
    { id: '28', code: 'HT', name: 'Haïti', phoneCode: '+509' },
    { id: '29', code: 'MG', name: 'Madagascar', phoneCode: '+261' },
    { id: '30', code: 'ML', name: 'Mali', phoneCode: '+223' },
    { id: '31', code: 'MU', name: 'Maurice', phoneCode: '+230' },
    { id: '32', code: 'MR', name: 'Mauritanie', phoneCode: '+222' },
    { id: '33', code: 'MC', name: 'Monaco', phoneCode: '+377' },
    { id: '34', code: 'NE', name: 'Niger', phoneCode: '+227' },
    { id: '35', code: 'RW', name: 'Rwanda', phoneCode: '+250' },
    { id: '36', code: 'LC', name: 'Sainte-Lucie', phoneCode: '+1758' },
    { id: '37', code: 'SN', name: 'Sénégal', phoneCode: '+221' },
    { id: '38', code: 'SC', name: 'Seychelles', phoneCode: '+248' },
    { id: '39', code: 'TD', name: 'Tchad', phoneCode: '+235' },
    { id: '40', code: 'TG', name: 'Togo', phoneCode: '+228' },
    { id: '41', code: 'VU', name: 'Vanuatu', phoneCode: '+678' },
    { id: '42', code: 'MF', name: 'Saint-Martin', phoneCode: '+1721' },
    { id: '43', code: 'GF', name: 'Guyane', phoneCode: '+594' },
    { id: '44', code: 'PM', name: 'Saint-Pierre-et-Miquelon', phoneCode: '+508' },
    { id: '45', code: 'YT', name: 'Mayotte', phoneCode: '+262' },
    { id: '46', code: 'BL', name: 'Saint-Barthélemy', phoneCode: '+590' },
    { id: '47', code: 'WF', name: 'Wallis-et-Futuna', phoneCode: '+681' },
    { id: '48', code: 'NC', name: 'Nouvelle-Calédonie', phoneCode: '+687' },
    { id: '49', code: 'NO', name: 'Norvège', phoneCode: '+47' }
];


const selectPays = ({ value, onChange, required = false, className }) => {
    return (
        <FormControl fullWidth className={className}>
            <InputLabel id="libellePays">Pays</InputLabel>
            <Select
                labelId="libellePays"
                label="Pays"
                value={value}
                onChange={onChange}
                required={required}
                name="pays"
            >
                {PAYS.map(pays => (
                    <MenuItem key={pays.id} value={pays.id}>
                        {pays.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default selectPays;